module.exports = __webpack_public_path__ + "images/bg-img-start-mobile_3c49c056ab2b460b00de940d15ff717c.png";